import gql from "graphql-tag";

export default gql`
  mutation Impersonate($userId: ObjectId!) {
    impersonate(userId: $userId) {
      token
    }
  }
`;
